import { Injectable, NgZone } from '@angular/core';
import { fromEvent, merge } from 'rxjs';
import { filter, throttleTime } from 'rxjs/operators';
import {WebsocketService} from "./websockets.service";

export function initActivity(activityService: TrackUserActivityService) {
	return () => activityService.init();
}

@Injectable({ providedIn: 'root' })
export class TrackUserActivityService {

	constructor(private zone: NgZone, private ws: WebsocketService) {
	}

	public init() {
		// Runs as an APP_INITIALIZER, which also executes during server-side
		// prerendering where there is no `document` to attach listeners to.
		if (typeof document === 'undefined') {
			return;
		}
		this.zone.runOutsideAngular(() => {
			const mouseMove$ = fromEvent(document, 'mousemove', { passive: true }).pipe(throttleTime(10_000));
			const tabVisible$ = fromEvent(document, 'visibilitychange').pipe(
				filter(() => document.visibilityState === 'visible')
			);

			merge(mouseMove$, tabVisible$).subscribe(() => {
				this.ws.markActivity();
			});
		});
	}
}
